import { createFileRoute } from '@tanstack/react-router';

import { VisualQaRenderPage } from '../features/visual-qa/visual-qa-render-page';

/**
 * Internal render surface for the Remote MCP Visual QA browser worker. It has no
 * data access of its own: it renders only a scene the worker injected into the
 * page before load, never one named by the URL. Without an injected scene it
 * renders nothing.
 */
export const Route = createFileRoute('/visual-qa/render')({ component: VisualQaRenderPage });
